<!--
 * @Author: mobai
 * @Date: 2022-07-12 19:32:30
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-26 19:18:15
 * @FilePath: \qym-lishui\src\gov\views\fiveStageCultivation\components\center.vue
-->
<template>
  <div class="center-box">
    <div class="label-list">
      <el-tooltip
        class="item"
        effect="dark"
        :content="item.labelName"
        placement="top"
        v-for="(item, index) in labelList"
        :key="index"
      >
        <div
          :class="[
            'label-list-item',
            selectLabelIdList.includes(item.labelId) ? 'active' : ''
          ]"
          :key="index"
          @click="clickLabelItem(item)"
        >
          <div class="label-name">{{ item.labelName }}</div>
        </div>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { getEntLabelFillList } from '@api/dataMaintenance/dataMaintenance'
export default {
  name: 'CockpitCenter',
  data() {
    return {
      labelList: [],
      selectLabelIdList: [], // 选择项
      reverseSelectionItem: [] // 反选项
    }
  },
  props: {
    leftLabelList: {
      type: Array,
      default: () => []
    },
    leftRemoveLabel: {
      type: Number,
      default: null
    }
  },
  watch: {
    leftLabelList: {
      handler(val) {
        if (val.length) {
          // 中间标签，是否存在已经左侧选中的，标签，如果存在，则需要选中
          this.labelList.map((k) => {
            val.map((item) => {
              if (k.labelId === item.id) {
                let index = this.selectLabelIdList.findIndex(
                  (d) => d === item.id
                )
                if (index < 0) {
                  this.selectLabelIdList.push(item.id)
                }
              }
            })
          })
        } else {
          this.selectLabelIdList = []
        }
      },
      deep: true
    },
    leftRemoveLabel(val) {
      // 移除项，如果存在选中，则需要移除选中
      let index = this.selectLabelIdList.findIndex((d) => d === val)
      if (index > -1) {
        this.selectLabelIdList.splice(index, 1)
      }
    }
  },
  mounted() {
    this.getEntLabelFillList()
  },
  methods: {
    // 获取8个标签列表
    getEntLabelFillList() {
      getEntLabelFillList().then((res) => {
        if (res.data.code === '0000') {
          this.labelList = res.data.data
          this.leftLabelList.map((item) => {
            this.labelList.map((k) => {
              if (k.labelId === item.id) {
                this.selectLabelIdList.push(item.id)
              }
            })
          })
        }
      })
    },
    clickLabelItem(data) {
      this.reverseSelectionItem = []
      let index = this.selectLabelIdList.findIndex(
        (item) => item === data.labelId
      )
      if (index > -1) {
        this.reverseSelectionItem.push(data.labelId)
        this.selectLabelIdList.splice(index, 1)
      } else {
        this.selectLabelIdList.push(data.labelId)
      }
      // console.log(this.selectLabelIdList)
      this.$emit('getSelectLabel', {
        selectLabelIdList: this.selectLabelIdList,
        reverseSelectionItem: this.reverseSelectionItem
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.center-box {
  width: 9rem;
  .label-list {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
  }
  .label-list-item {
    margin-right: 0.16rem;
    margin-bottom: 0.1rem;
    background: url('~@/assets/nomal.png') no-repeat;
    background-size: 100% 100%;
    border-left: 0;
    border-right: 0;
    color: rgba(199, 218, 255, 65);
    position: relative;
    .label-name {
      width: 2rem;
      height: 0.32rem;
      padding: 0 0.2rem;
      // box-sizing: border-box;
      line-height: 0.32rem;
      text-align: center;
      font-size: 0.16rem;
      cursor: pointer;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: keep-all;
    }
    &.active {
      color: rgba(255, 255, 255, 1);
      background-color: #112455;
      background: url('~@/assets/hover.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
